<template>
    <v-layout row class="app-content">
        <v-flex xs12 md6>
            <v-layout class="form-layout" row wrap pa-5 align-center>
                <loading ref="loading" :show_overlay="false">
                    <v-form ref="form" @submit.prevent="enviar">
                        <v-layout row wrap align-center style="width: 100%;">
                            <v-layout justify-center align-center>
                                <img class="logo" src="../assets/img/unifisa-logo.png"/>
                                <img class="logo" src="../assets/img/alper-logo.png"/>
                                <img class="logo" style="max-width: 200px;" src="../assets/img/unifisa-parceiros-logo.png"/>
                                <img class="logo" style="max-width: 200px;" src="../assets/img/casas-bahia-logo.png"/>
                            </v-layout>
                        </v-layout>
                        <v-text-field label="Login"
                                      v-model="login"
                                      :rules="[rules.required]"
                                      prepend-icon="ol-perm_identity"
                                      append-icon=" "
                                      maxlength="50"/>
                        <v-text-field label="Senha"
                                      :type="pass_visible ? 'text' : 'password'"
                                      v-model="senha"
                                      :rules="[rules.required]"
                                      prepend-icon="ol-lock"
                                      maxlength="20">
                            <v-icon slot="append" @click="pass_visible = !pass_visible"
                                    :color="pass_visible ? 'primary' : undefined">ol-visibility
                            </v-icon>
                        </v-text-field>
                        <v-flex offset-xs6>
                            <v-btn class="btn-default primary" type="sumbit">Entrar</v-btn>
                        </v-flex>
                    </v-form>
                </loading>
            </v-layout>
        </v-flex>
        <v-flex class="bg" hidden-sm-and-down md6></v-flex>
<!--        <div class="primary dash hidden-sm-and-down"></div>-->
    </v-layout>
</template>

<script>

import Rules from '../plugins/validation'
import { error, sleep } from '../plugins/helpers'
import Loading from '../components/Loading'
import { mapMutations } from 'vuex'

export default {
  components: { Loading },
  data: () => ({
    pass_visible: false,
    login: '',
    senha: ''
  }),
  computed: {
    rules: () => Rules
  },
  created () {
    this.resetCores()
  },
  methods: {
    ...mapMutations(['setPerfil', 'setUnidadeNegocio']),
    enviar () {
      const form = this.$refs.form
      const loading = this.$refs.loading

      if (form.validate()) {
        loading.start()

        this.$http.post('/admin/usuarios/login', {
          _l: this.login,
          _s: this.senha
        }, {
          options: {
            silent: true
          }
        }).then(res => {
          const token = res.data['Token']
          const id_usuario = res.data['ID_Usuario']
          const nome = res.data['NM_Pessoa']
          const perfil = res.data['Perfil']
          const painel_lead = res.data['PainelLead']

          if (token && id_usuario) {
            this.$session.start()
            this.$session.set('id_usuario', id_usuario)
            this.$session.set('nome', nome)
            this.$session.set('token', token)
            this.$session.set('painel_lead', painel_lead)
            this.setPerfil(perfil)

            return this.$http.get(`/admin/usuarios/${this.$session.get('id_usuario')}/unidadenegocio`)
          }
        }).then((r) => {
          this.setUnidadeNegocio(r.data.id_unidade_negocio)
          this.$session.set('id_unidade_negocio', r.data.id_unidade_negocio)
          this.$router.replace('/')
        }).catch(err => {
          this.$session.destroy()
          error(err, 'Não foi possível autenticar.')
        }).finally(() => {
          loading.done()
        })
      } else {
        form.resetValidation()
        sleep(100).then(() => form.validate())
      }
    },
    resetCores () {
      this.$set(this.$vuetify, 'theme', {
        primary: '#2196F3',
        secondary: '#221551',
        accent: '#221551',
        error: '#221551',
        info: '#221551',
        success: '#4CAF50',
        warning: '#FFC107',
        neutral: '#f5f5f5',
        lightgrey: '#eeeeee',
        grey: '#d5d5d5',
        dark: '#606060'
      })
    }
  }
}
</script>

<style scoped>
    .app-content {
        background: white;
    }

    .logo {
        width: 100%;
        max-width: 250px;
        margin: 0 10px;
    }

    .bg {
        background: url(../assets/img/login-bg.jpg) center center/cover no-repeat;
        width: 58%;
        height: 100%;
        position: fixed;
        right: 0;
        min-height: 100%;
    }

    form {
        width: 100%;
    }

    .form-layout {
        max-width: 500px;
        height: 100%;
        margin: auto;
    }

    .dash {
        position: absolute;
        top: calc(50% - 1px);
        left: calc(50% - 50px);
        height: 2px;
        width: 100px;
    }
</style>
